import { render, staticRenderFns } from "./documentsListView.vue?vue&type=template&id=5e1e5620&"
import script from "./documentsListView.vue?vue&type=script&lang=js&"
export * from "./documentsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports